import React, { useRef, useState, useEffect } from 'react';
import './Carousel.scss';
import { useSwipeable } from 'react-swipeable';
import apollo from '../../../assets/suits/apollo.png';
import contemporary from '../../../assets/suits/contemporary.png';
import artemis from '../../../assets/suits/artemis.png';
import future from '../../../assets/suits/future.png';
import Indicator from '../../Common/Indicator/Indicator';
import Arrows from './Arrows';
import { navItems } from '../../../navItems';

function Carousel({ currentEra, setCurrentEra, showArrow }) {
  const images = [apollo, contemporary, artemis, future];
  const length = images.length - 1;
  const [currentLeft, setCurrentLeft] = useState(2);
  const [currentRight, setCurrentRight] = useState(0);
  const [animateEra, setAnimateEra] = useState(3);
  const [animateLeft, setAnimateLeft] = useState(2);
  const [animateRight, setAnimateRight] = useState(0);
  const [queue, setQueue] = useState(1);

  const currentRightRef = useRef();
  const currentLeftRef = useRef();
  const currentEraRef = useRef();
  const queueRef = useRef();
  const animationRef = useRef();
  const actualRef = useRef();
  const arrowsRef = useRef();

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClickSuits('right'),
    onSwipedRight: () => handleClickSuits('left')
  });

  const handleClickSuits = (direction) => {
    window.dataLayer.push({ event: 'carousel_direction' });
    actualRef.current.style.opacity = '0';
    animationRef.current.style.opacity = '1';
    queueRef.current.style.opacity = 1;
    if (arrowsRef.current) {
      arrowsRef.current.style.opacity = '0';
      arrowsRef.current.style.pointerEvents = 'none';
    }

    if (direction === 'left') {
      setCurrentEra(currentLeft);
      setCurrentLeft(currentLeft === 0 ? length : currentLeft - 1);
      setCurrentRight(currentEra);
      currentLeftRef.current.style.animation = 'moveRightAndScaleUp 1s ease';
      currentEraRef.current.style.animation = 'moveRightAndScaleDown 1s ease';
      currentRightRef.current.style.animation = 'fade-out 1s ease';
      queueRef.current.style.animation = 'moveLeft 1s ease';
    } else if (direction === 'right') {
      setCurrentEra(currentRight);
      setCurrentLeft(currentEra);
      setCurrentRight(currentRight === length ? 0 : currentRight + 1);
      currentRightRef.current.style.animation = 'moveLeftAndScaleUp 1s ease';
      currentEraRef.current.style.animation = 'moveLeftAndScaleDown 1s ease';
      currentLeftRef.current.style.animation = 'fade-out 1s ease';
      queueRef.current.style.animation = 'moveRight 1s ease';
    }
  };
  useEffect(() => {
    setTimeout(() => {
      actualRef.current.style.opacity = '1';
      animationRef.current.style.opacity = '0';
      queueRef.current.style.opacity = 0;
    }, 1000);
    setTimeout(() => {
      setAnimateEra(currentEra);
      setAnimateLeft(currentLeft);
      setAnimateRight(currentRight);
      setQueue(currentLeft === 0 ? length : currentLeft - 1);
      currentLeftRef.current.style.animation = '';
      currentEraRef.current.style.animation = '';
      currentRightRef.current.style.animation = '';
      queueRef.current.style.animation = '';
      if (arrowsRef.current) {
        arrowsRef.current.style.opacity = '1';
        arrowsRef.current.style.pointerEvents = 'auto';
      }
    }, 1100);
  }, [currentEra, currentLeft, currentRight, length]);

  return (
    <div className="carousel">
      <div className="carousel__contents">
        <h3 className="carousel__contents__title">
          Explore how spacesuits have changed over the years
        </h3>
        <div className="carousel__contents__suits" {...handlers}>
          {showArrow && <Arrows handleClickSuits={handleClickSuits} arrowsRef={arrowsRef} />}

          <div className="carousel__contents__suits-container" ref={actualRef}>
            <img
              src={images[currentLeft]}
              alt={navItems[currentLeft].copy}
              className="carousel__contents__suits__suit carousel__contents__suits__suit-left"
            />

            <img
              src={images[currentEra]}
              alt={navItems[currentEra].copy}
              className="carousel__contents__suits__suit carousel__contents__suits__suit-center"
            />

            <img
              src={images[currentRight]}
              alt={navItems[currentRight].copy}
              className="carousel__contents__suits__suit  carousel__contents__suits__suit-right"
            />
          </div>
          <div className="carousel__contents__suits-container" ref={animationRef}>
            <div className="carousel__contents__suits-container__animation">
              <img
                ref={currentLeftRef}
                src={images[animateLeft]}
                alt={navItems[animateLeft].copy}
                className="carousel__contents__suits__suit carousel__contents__suits__suit-left"
              />
              <img
                ref={queueRef}
                src={images[queue]}
                alt={navItems[queue].copy}
                className="carousel__contents__suits__suit carousel__contents__suits__suit-queue"
              />

              <img
                ref={currentEraRef}
                src={images[animateEra]}
                alt={navItems[animateEra].copy}
                className="carousel__contents__suits__suit carousel__contents__suits__suit-center"
              />

              <img
                ref={currentRightRef}
                src={images[animateRight]}
                alt={navItems[animateRight].copy}
                className="carousel__contents__suits__suit  carousel__contents__suits__suit-right"
              />
            </div>
          </div>
        </div>
        <Indicator currentEra={currentEra} eras={navItems} origin="carousel" />
        <h2 className="carousel__contents__name">{navItems[currentEra].copy}</h2>
        <a href={`#${navItems[currentEra].href}`} className="carousel__contents__button">
          <button
            className="carousel__contents__button"
            id={`explore_${navItems[currentEra].href}`}
          >
            EXPLORE
          </button>
        </a>
      </div>
    </div>
  );
}

export default Carousel;
